import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import {
  SchoolSubjectLevelAndStreamModel,
  Subject,
} from "@modules/student-group/student-group-types.ts";

const getAdministrableSubjects = () => {
  return httpClient.get(`/apis/subjects/administrable`);
};

const getAdministratedSubjects = () => {
  return httpClient.get(`/apis/subjects/administrated`);
};

const getSubjects = (params) => {
  return httpClient.get(`/apis/subject/list`, { params: params });
};

const getSubject = (uuid) => {
  return httpClient.get(`/apis/subject/${uuid}`);
};

const getSubjectTemplateLink = () => {
  return httpClient.get(`/apis/subject/template-link`);
};

const createSubject = (data) => {
  return httpClient.post(`/apis/subject/create`, data);
};

const deleteSubject = (uuid) => {
  return httpClient.post(`/apis/subject/delete/${uuid}`);
};

const getSubjectPermissions = (uuid) => {
  return httpClient.get(`/apis/subject/permission/${uuid}`);
};

const saveSubject = (data) => {
  return httpClient.post(`/apis/subject/edit`, data);
};

const fetchSubjectLevelAndStreamMetadata = (requestData: {
  subjectId: number;
  levelAndStreamId: number;
}): Promise<ApiResponse<SchoolSubjectLevelAndStreamModel>> => {
  return httpClient.get(`/apis/subject/level-stream`, {
    params: requestData,
  });
};

const getAllSubjectsBySchool = (schoolId) => {
  const params = { schoolId };
  return httpClient.get(`/apis/subject/all`, { params });
};

const getAllMOEDistinctSubjects = () => {
  return httpClient.get(`/apis/subject/distinct/moe`);
};

const getMoeSubjects = () => {
  return httpClient.get(`/apis/moe-subjects`);
};

const getCategorizedSubjects = (subjectIds?: number[]): Promise<ApiResponse<Subject[]>> => {
  return httpClient.get(`/apis/subject/categorized`, {
    params: subjectIds?.length ? { subjectIds: subjectIds.join(",") } : undefined,
  });
};

export default {
  getAdministrableSubjects,
  getAdministratedSubjects,
  getSubjects,
  getSubject,
  getSubjectTemplateLink,
  createSubject,
  deleteSubject,
  getSubjectPermissions,
  saveSubject,
  fetchSubjectLevelAndStreamMetadata,
  getAllSubjectsBySchool,
  getAllMOEDistinctSubjects,
  getMoeSubjects,
  getCategorizedSubjects,
};
